import { NextSeo } from "next-seo"
import Head from "next/head"
import React from "react"

import { ContactUsView } from "@modules/contactUs/contactUsView"

const TITLE = "Qeeper | Contact Us"
const DESC = "Qeeper contact us"

const SEO_KEYWORDS = "Qeeper contact us page"

const ContactUs = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        openGraph={{
          title: TITLE,
          description: DESC,
        }}
      />
      <>
        <ContactUsView />
      </>
    </>
  )
}

export default ContactUs